import { FC } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Grid } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";

interface Props {
    label: string;
    name: string;
    value: Dayjs | null;
    columnSize: number[];
    minDate: Dayjs | null;
    maxDate: Dayjs | null;
    errorInput: string[];
    handleChange: (e: Dayjs | null, name: string) => void;
}

const Input: FC<Props> = ({
    label,
    name,
    value,
    columnSize,
    minDate,
    maxDate,
    errorInput,
    handleChange
}) => {
    const [xsValue, smValue, mdValue] = columnSize;

    return (
        <Grid item xs={xsValue} sm={smValue} md={mdValue}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label={label}
                    views={["year"]}
                    value={value}
                    onChange={(e) => handleChange(e, name)}
                    minDate={minDate}
                    maxDate={maxDate}
                    slotProps={{
                        textField: {
                            // size: 'small',
                            color: "warning",
                            fullWidth: true,
                            error: errorInput.includes(name)
                        },
                    }}
                    sx={{
                        '& .MuiYearPicker-year.Mui-selected': { // Sélecteur plus spécifique
                            backgroundColor: 'orange !important',
                        },
                    }}
                />
            </LocalizationProvider>
        </Grid>
    );
};

export default Input;